// GENERATED by tools/single-file.py — the ladders below are loop regions inside one bounced
// file, not hand-written numbers. Re-render with:
//   npx vite-node tools/dump-banks.mts /tmp/rerender/banks.json
//   python3 tools/single-file.py /tmp/rerender/banks.json ferrari-812-4v /tmp/rerender/ferrari-812   (sources: see the docstring)
//   python3 tools/single-file.py encode ferrari-812-4v /tmp/rerender/ferrari-812 && python3 tools/apply-ladders.py ...
import type { EngineLoopSample } from '../CarProfile';
import { asSingleFile } from '../single-file';
import { ferrari812 } from '../ferrari-812';

const loop = (id: string, file: string, recordedRpm: number, loopStart: number, loopEnd: number): EngineLoopSample =>
  ({ id, file, recordedRpm, loopStart, loopEnd });

export const ferrari812Single = asSingleFile(ferrari812, {
  id: 'ferrari-812',
  slug: '800-hp-v12',
  name: '800 HP V12',
  baseGain: 1.468,
  adminOnly: false,  // LIVE 2026-09-02 — see the licence note in ../ferrari-812.ts

  limiter: { id: 'limiter', file: 'limiter_single.flac', recordedRpm: 8900 },
  on: [
  loop('on_800', 'single', 800, 0.000000, 11.989833),
  loop('on_1312', 'single', 1312, 11.989833, 25.489833),
  loop('on_1650', 'single', 1650, 25.489833, 40.486104),
  loop('on_2260', 'single', 2260, 40.486104, 42.485354),
  loop('on_3170', 'single', 3170, 42.485354, 44.482333),
  loop('on_4015', 'single', 4015, 44.482333, 46.481563),
  loop('on_4791', 'single', 4791, 46.481563, 48.480979),
  loop('on_5150', 'single', 5150, 48.480979, 50.480167),
  loop('on_5609', 'single', 5609, 50.480167, 52.480063),
  loop('on_5932', 'single', 5932, 52.480063, 54.478375),
  loop('on_6382', 'single', 6382, 54.478375, 56.478375),
  loop('on_6733', 'single', 6733, 56.478375, 58.478375),
  loop('on_7227', 'single', 7227, 58.478375, 60.478063),
  loop('on_7630', 'single', 7630, 60.478063, 62.477583),
  loop('on_8030', 'single', 8030, 62.477583, 64.477146),
  loop('on_8828', 'single', 8828, 64.477146, 66.476396),
  ],
  mid: [
  loop('mid_800', 'single', 800, 66.476396, 78.466229),
  loop('mid_1312', 'single', 1312, 78.466229, 91.958604),
  loop('mid_1650', 'single', 1650, 91.958604, 106.957979),
  loop('mid_2260', 'single', 2260, 106.957979, 108.957437),
  loop('mid_3170', 'single', 3170, 108.957437, 110.956312),
  loop('mid_4015', 'single', 4015, 110.956312, 112.954333),
  loop('mid_4791', 'single', 4791, 112.954333, 114.953625),
  loop('mid_5150', 'single', 5150, 114.953625, 116.953083),
  loop('mid_5609', 'single', 5609, 116.953083, 118.951292),
  loop('mid_5932', 'single', 5932, 118.951292, 120.949604),
  loop('mid_6382', 'single', 6382, 120.949604, 122.949438),
  loop('mid_6733', 'single', 6733, 122.949438, 124.948167),
  loop('mid_7227', 'single', 7227, 124.948167, 126.947417),
  loop('mid_7630', 'single', 7630, 126.947417, 128.947062),
  loop('mid_8030', 'single', 8030, 128.947062, 130.947062),
  loop('mid_8828', 'single', 8828, 130.947062, 132.947062),
  ],
  off: [
  loop('off_800', 'single', 800, 132.947062, 144.936896),
  loop('off_1312', 'single', 1312, 144.936896, 158.432896),
  loop('off_1650', 'single', 1650, 158.432896, 173.432896),
  loop('off_2260', 'single', 2260, 173.432896, 175.432896),
  loop('off_3170', 'single', 3170, 175.432896, 177.432896),
  loop('off_4015', 'single', 4015, 177.432896, 179.430396),
  loop('off_4791', 'single', 4791, 179.430396, 181.428375),
  loop('off_5150', 'single', 5150, 181.428375, 183.428167),
  loop('off_5609', 'single', 5609, 183.428167, 185.427146),
  loop('off_5932', 'single', 5932, 185.427146, 187.426417),
  loop('off_6382', 'single', 6382, 187.426417, 189.426021),
  loop('off_6733', 'single', 6733, 189.426021, 191.425625),
  loop('off_7227', 'single', 7227, 191.425625, 193.425187),
  loop('off_7630', 'single', 7630, 193.425187, 195.425062),
  loop('off_8030', 'single', 8030, 195.425062, 197.425062),
  loop('off_8828', 'single', 8828, 197.425062, 199.425062),
  ],
});
